/* ===========================================================
   ANTRE ARDENTE — moteur atmosphérique
   • braises voltigeantes (canvas, composition additive)
   • assombrissement progressif piloté au scroll
   • intensification des braises à l'approche de la forge (footer)
   =========================================================== */
(function () {
  "use strict";

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  var canvas = document.getElementById("emberCanvas");
  var veil   = document.getElementById("descentVeil");
  if (!canvas) return;

  var ctx = canvas.getContext("2d");
  var W = 0, H = 0, DPR = Math.min(window.devicePixelRatio || 1, 2);

  function resize() {
    W = window.innerWidth;
    H = window.innerHeight;
    canvas.width  = Math.floor(W * DPR);
    canvas.height = Math.floor(H * DPR);
    canvas.style.width  = W + "px";
    canvas.style.height = H + "px";
    ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
  }
  resize();
  window.addEventListener("resize", resize, { passive: true });

  var descent = 0.4;

  var TEMP_STOPS = [
    [0.00, [150,  36,  16]],
    [0.30, [214,  74,  28]],
    [0.55, [248, 120,  44]],
    [0.78, [255, 176,  84]],
    [1.00, [255, 238, 198]]
  ];
  function tempColor(t) {
    t = t < 0 ? 0 : t > 1 ? 1 : t;
    for (var i = 1; i < TEMP_STOPS.length; i++) {
      if (t <= TEMP_STOPS[i][0]) {
        var a = TEMP_STOPS[i - 1], b = TEMP_STOPS[i];
        var f = (t - a[0]) / (b[0] - a[0]);
        return [
          (a[1][0] + (b[1][0] - a[1][0]) * f) | 0,
          (a[1][1] + (b[1][1] - a[1][1]) * f) | 0,
          (a[1][2] + (b[1][2] - a[1][2]) * f) | 0
        ];
      }
    }
    return TEMP_STOPS[TEMP_STOPS.length - 1][1];
  }

  function makeFlake() {
    var n = 3 + ((Math.random() * 4) | 0);
    var pts = [];
    for (var i = 0; i < n; i++) {
      var ang = (i / n) * Math.PI * 2 + (Math.random() - 0.5) * 0.7;
      var rad = 0.45 + Math.random() * 0.85;
      pts.push([Math.cos(ang) * rad, Math.sin(ang) * rad]);
    }
    return pts;
  }

  function spawn(fromBottomBias) {
    var size = 0.9 + Math.random() * 2.4;
    var streak = Math.random() < 0.35;
    var startY = fromBottomBias
      ? H + 8 + Math.random() * 40
      : H * (0.4 + Math.random() * 0.65);
    return {
      x: Math.random() * W,
      y: startY,
      vx: (Math.random() - 0.5) * 0.35,
      vy: -(0.7 + Math.random() * 1.3),
      size: size,
      flake: makeFlake(),
      aspect: streak ? 1.6 + Math.random() * 1.4 : 1 + Math.random() * 0.4,
      angle: Math.random() * Math.PI * 2,
      spin: (Math.random() - 0.5) * 0.12,
      tA: Math.random() * Math.PI * 2,
      tB: Math.random() * Math.PI * 2,
      tAs: 0.012 + Math.random() * 0.03,
      tBs: 0.03 + Math.random() * 0.05,
      sway: 0.12 + Math.random() * 0.4,
      buoy: 0.018 + Math.random() * 0.014,
      cool: 0.7 + Math.random() * 0.6,
      flPhase: Math.random() * Math.PI * 2,
      flSpeed: 0.12 + Math.random() * 0.16,
      life: 0,
      maxLife: 150 + Math.random() * 280
    };
  }

  var particles = [];
  var BASE = reduce ? 0 : Math.round((W * H) / 19000);
  BASE = Math.min(BASE, 120);

  for (var i = 0; i < BASE * 0.6; i++) {
    var p = spawn(false);
    p.life = Math.random() * p.maxLife;
    particles.push(p);
  }

  var t = 0;
  function frame() {
    t++;

    var intensity = 0.5 + descent * 0.9;
    var targetCount = Math.round(BASE * intensity);

    var deficit = targetCount - particles.length;
    var emit = Math.max(0, Math.min(deficit, 2));
    for (var e = 0; e < emit; e++) particles.push(spawn(true));

    ctx.clearRect(0, 0, W, H);
    ctx.globalCompositeOperation = "lighter";

    var wind = Math.sin(t * 0.006) * 0.18 + Math.sin(t * 0.013) * 0.1;

    for (var k = particles.length - 1; k >= 0; k--) {
      var q = particles[k];
      q.life++;
      var lifeRatio = q.life / q.maxLife;

      var temp = 1 - lifeRatio * q.cool;
      if (temp < 0) temp = 0;

      q.vy += 0.011 - q.buoy * temp;
      q.tA += q.tAs; q.tB += q.tBs;
      var turb = (Math.sin(q.tA) + Math.sin(q.tB) * 0.6) * q.sway * (0.5 + temp * 0.7);
      q.vx += (turb + wind - q.vx) * 0.06;

      q.x += q.vx * (1 + intensity * 0.3);
      q.y += q.vy * (0.8 + intensity * 0.4);
      q.angle += q.spin * (0.6 + temp);

      var fade = lifeRatio < 0.08 ? lifeRatio / 0.08
               : lifeRatio > 0.72 ? (1 - lifeRatio) / 0.28
               : 1;
      q.flPhase += q.flSpeed;
      var flick = 0.72 + 0.28 * Math.sin(q.flPhase);
      var alpha = Math.max(0, fade) * flick * (0.28 + temp * 0.72) * (0.6 + intensity * 0.4);

      if (lifeRatio >= 1 || q.y < -30 || q.x < -40 || q.x > W + 40) {
        particles.splice(k, 1);
        continue;
      }
      if (alpha <= 0.015) continue;

      var col = tempColor(temp);
      var cr = col[0], cg = col[1], cb = col[2];

      var hr = q.size * 2.2;
      var halo = ctx.createRadialGradient(q.x, q.y, 0, q.x, q.y, hr);
      halo.addColorStop(0, "rgba(" + cr + "," + cg + "," + cb + "," + (alpha * 0.5) + ")");
      halo.addColorStop(1, "rgba(" + cr + "," + cg + "," + cb + ",0)");
      ctx.fillStyle = halo;
      ctx.beginPath();
      ctx.arc(q.x, q.y, hr, 0, Math.PI * 2);
      ctx.fill();

      ctx.save();
      ctx.translate(q.x, q.y);
      ctx.rotate(q.angle);
      ctx.scale(q.aspect, 1 / Math.sqrt(q.aspect));
      var f = q.flake, s = q.size;
      ctx.beginPath();
      ctx.moveTo(f[0][0] * s, f[0][1] * s);
      for (var v = 1; v < f.length; v++) ctx.lineTo(f[v][0] * s, f[v][1] * s);
      ctx.closePath();
      ctx.fillStyle = "rgba(" + cr + "," + cg + "," + cb + "," + alpha + ")";
      ctx.fill();
      if (temp > 0.7) {
        ctx.fillStyle = "rgba(255,244,214," + (alpha * (temp - 0.7) * 2.6) + ")";
        ctx.beginPath();
        ctx.arc(0, 0, s * 0.5, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.restore();
    }

    ctx.globalCompositeOperation = "source-over";
    requestAnimationFrame(frame);
  }

  requestAnimationFrame(function () {
    canvas.classList.add("lit");
    if (!reduce) requestAnimationFrame(frame);
  });
})();
